<div class="file-input-wrapper">
  <!-- INPUT FIELD: FAKE FILE INPUT -->
  <div class="file-input-field stretch">
    <mat-form-field>
      <input
        [(ngModel)]="fileName"
        matInput
        fileDrop
        [title]="file ? file?.name : ''"
        [placeholder]="placeholder"
        (dropped)="handleSelect($event)"
        (click)="fileInput.click()"
        (keyup.enter)="fileInput.click()"
        (keyup.delete)="clear()"
        (keyup.backspace)="clear()"
        [required]="required"
        readonly
        class="text-mobile-ellipse"
      />
    </mat-form-field>

    <button
      type="button"
      mat-icon-button
      *ngIf="file"
      (click)="clear()"
      (keyup.enter)="clear()"
    >
      <span class="material-icons">clear</span>
    </button>
  </div>
  <!-- BUTTON FOR BETTER USER EXPERIENCE -->
  <button
    *ngIf="!enableUploadAction || (enableUploadAction && !file) "
    type="button"
    fileDrop
    mat-raised-button
    class="margin-right-0"
    [disabled]="disabled"
    (keyup.enter)="fileInput.click()"
    (click)="fileInput.click()"
    color="secondary"
    (dropped)="handleSelect($event)"
  >
    <ng-content></ng-content>
  </button>
  <!-- UPLOAD BUTTON UPON ENABLE_UPLOAD_ACTION -->
  <button
    *ngIf="enableUploadAction && file"
    type="button"
    mat-raised-button
    color="primary"
    class="margin-right-0"
    (click)="onUpload()"
    [disabled]="disableUploadAction"
  >
    Upload
  </button>
  <input
    fileSelect
    #fileInput
    class="file-input-hidden"
    type="file"
    (fileSelect)="handleSelect($event)"
  />
</div>
